import { Directional } from '../src/app/interfaces/directional';

export const DIRECTIONAL: Directional[] = [
  {
    wellId: '5400002971',
    wellboreId: 'l6KARXG88j',
    wellboreNo: 'OH',
    maxInclination: 2.6,
    maxDoglegSev: 0.395,
    mdMaxDoglegSev: 2254.4,
    kopTvdStimated: 0.0,
  },
];
